import { render, staticRenderFns } from "./base-upload.vue?vue&type=template&id=2798afba&scoped=true&"
import script from "./base-upload.vue?vue&type=script&lang=js&"
export * from "./base-upload.vue?vue&type=script&lang=js&"
import style1 from "./base-upload.vue?vue&type=style&index=1&id=2798afba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2798afba",
  null
  
)

export default component.exports